export enum AppointmentType {
	WEB = 'WEB_FORM_ATTACHMENT',
	DOCUMENT = 'ATTACHMENT',
	LEGACY_WEB = 'WEB_FORM_V1',
}
